import CstLinkToken from 'features/auth/components/CstLinkToken/CstLinkToken';
import React from 'react';

export default function Page() {
  return <CstLinkToken />;
}
